import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { ShippingFeeSettingsPanel } from '@/widgets/shipping-fee-settings-panel';

/** 배송비 설정(/settings/shipping-fee, 사이드바 '설정 > 배송비 설정' — SUPER-86 D9) — 설정 위젯을 조합만 한다. */
export const ShippingFeeSettingsPage = (): ReactElement => (
  <>
    <PageHeader
      title="배송비 설정"
      description="배송지 1곳마다 붙는 기본 배송비와 제주·도서산간 추가 금액을 정합니다. 바꾼 금액은 재배포 없이 다음 견적 요청부터 적용됩니다."
    />
    <ShippingFeeSettingsPanel />
  </>
);
